import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { useSettings } from './hooks/useSettings';

// Components
import Navbar from './components/Navbar';
import CartDrawer from './components/CartDrawer';
import AdminToggle from './components/AdminToggle';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import GalleriaPage from './pages/GalleriaPage';
import ArtworkDetailPage from './pages/ArtworkDetailPage';
import AboutPage from './pages/AboutPage';
import ContattiPage from './pages/ContattiPage';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';

// Layout for store pages (with Navbar and Footer)
function StoreLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

// Protected route for admin
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-light">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-dark"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

function FaviconSync() {
  const { settings } = useSettings();
  useEffect(() => {
    const url = settings.site_logo_url;
    if (!url || url.includes('placeholder')) return;
    const link = document.querySelector("link[rel='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = url;
    document.head.appendChild(link);
  }, [settings.site_logo_url]);
  return null;
}

function AppContent() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Store routes with Navbar and Footer */}
        <Route element={<StoreLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/galleria" element={<GalleriaPage />} />
          <Route path="/galleria/:id" element={<ArtworkDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
        </Route>

        {/* Admin routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Global overlays */}
      <CartDrawer />
      <AdminToggle />
      <FaviconSync />
    </BrowserRouter>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AppContent />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
